/* Size chart popup (snippets/size-chart.liquid). Wordt één keer per pagina uitgevoerd. */
(function () {
  if (window.__sizeChartLoaded) { window.__sizeChartInit && window.__sizeChartInit(); return; }
  window.__sizeChartLoaded = true;

  var STORAGE_KEY = 'sc-unit';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function parseTable(raw) {
    var lines = String(raw).replace(/\r/g, '').split('\n')
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l && !/^\|?[\s\-:|]+\|?$/.test(l); }); // lege regels en markdown-scheidingsregels overslaan
    if (!lines.length) return null;
    var first = lines[0];
    var sep = first.indexOf('\t') > -1 ? '\t' : first.indexOf('|') > -1 ? '|' : first.indexOf(';') > -1 ? ';' : ',';
    return lines.map(function (l) {
      if (sep === '|') l = l.replace(/^\|/, '').replace(/\|$/, '');
      return l.split(sep).map(function (c) { return c.trim(); });
    });
  }

  function fmt(n, unit) {
    var f = unit === 'in' ? 10 : 1; // inches: 1 decimaal, cm: hele getallen
    return String(Math.round(n * f) / f);
  }

  function convertCell(cell, from, to) {
    if (from === to) return cell;
    return cell.replace(/\d+(?:[.,]\d+)?/g, function (m) {
      var n = parseFloat(m.replace(',', '.'));
      return fmt(to === 'in' ? n / 2.54 : n * 2.54, to);
    });
  }

  function getSavedUnit() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function saveUnit(u) {
    try { localStorage.setItem(STORAGE_KEY, u); } catch (e) {}
  }

  function normSize(s) {
    return String(s).toUpperCase().replace(/\s+/g, '').replace(/^XXXXL$/, '4XL').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
  }

  // Rijen voor maten die dit product niet heeft worden verborgen, maar alleen als ALLE productmaten in de tabel staan
  function visibleRows(root, rows) {
    var raw = root.getAttribute('data-sizes');
    if (!raw) return rows;
    var sizes = raw.split('|').map(normSize).filter(Boolean);
    var labels = rows.map(function (r) { return normSize(r[0]); });
    var all = sizes.length && sizes.every(function (s) { return labels.indexOf(s) > -1; });
    if (!all) return rows;
    var kept = rows.filter(function (r) { return sizes.indexOf(normSize(r[0])) > -1; });
    return kept.length ? kept : rows;
  }

  function render(root, unit) {
    var d = root.__sc;
    var head = d.rows[0];
    var html = '<thead><tr>';
    head.forEach(function (h, i) {
      var convertible = i > 0 && !d.fixed[i];
      html += '<th scope="col">' + esc(d.labels[i]) + (convertible ? ' <span class="sc-u">(' + unit + ')</span>' : '') + '</th>';
    });
    html += '</tr></thead><tbody>';
    visibleRows(root, d.rows.slice(1)).forEach(function (row) {
      html += '<tr>';
      for (var i = 0; i < head.length; i++) {
        var cell = row[i] == null ? '' : row[i];
        if (i === 0) { html += '<th scope="row">' + esc(cell) + '</th>'; continue; }
        html += '<td>' + esc(d.fixed[i] ? cell : convertCell(cell, d.base, unit)) + '</td>';
      }
      html += '</tr>';
    });
    html += '</tbody>';
    root.querySelector('[data-sc-table]').innerHTML = html;
    root.querySelectorAll('[data-sc-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sc-unit') === unit ? 'true' : 'false');
    });
    root.__scUnit = unit;
  }

  function setup(root) {
    if (root.__scReady) return;
    var dataEl = root.querySelector('[data-sc-data]');
    var rows;
    var raw = '';
    try { raw = String(JSON.parse(dataEl.textContent)); } catch (e) {}
    var notes = [];
    raw = raw.split('\n').filter(function (l) {
      var mm = l.match(/^\s*note:\s*(.*)$/i);
      if (mm) { notes.push(mm[1]); return false; }
      return true;
    }).join('\n');
    try { rows = parseTable(raw); } catch (e) { rows = null; }
    if (notes.length) {
      var nd = document.createElement('div');
      nd.className = 'sc-note';
      nd.textContent = notes.join(' ');
      root.querySelector('.sc-table-wrap').insertAdjacentElement('afterend', nd);
    }
    if (!rows || rows.length < 2) { root.style.display = 'none'; return; }

    var fixed = [], labels = [];
    rows[0].forEach(function (h, i) {
      var m = h.match(/^\[(.*)\]$/);
      fixed[i] = !!m;
      labels[i] = (m ? m[1].trim() : h).replace(/\s*\((cm|in|inch|inches)\)\s*$/i, '');
    });
    root.__sc = { rows: rows, base: root.getAttribute('data-base-unit') === 'in' ? 'in' : 'cm', fixed: fixed, labels: labels };
    root.__scReady = true;

    var dialog = root.querySelector('dialog');
    var prevOverflow = '';

    root.querySelector('[data-sc-open]').addEventListener('click', function () {
      var unit = getSavedUnit() || root.getAttribute('data-default-unit');
      render(root, unit === 'cm' ? 'cm' : 'in');
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    });

    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = prevOverflow; });
    root.querySelector('[data-sc-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); }); // klik op achtergrond

    root.querySelectorAll('[data-sc-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-sc-unit');
        saveUnit(u);
        render(root, u);
      });
    });
  }

  window.__sizeChartInit = function () {
    document.querySelectorAll('[data-size-chart]').forEach(setup);
  };
  window.__sizeChartTest = { parseTable: parseTable, convertCell: convertCell, visibleRows: visibleRows };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__sizeChartInit);
  else window.__sizeChartInit();

  // Zet de 'Size guide'-link naast het Size-label (ook als een swatch-app het label later tekent)
  function placeInline() {
    // Staat de link er al (en is hij zichtbaar)? Dan niets doen: deze check is goedkoop, de rest niet
    var placed = document.querySelector('.sc-trigger--inline');
    if (placed && placed.isConnected && placed.getBoundingClientRect().width) return;
    document.querySelectorAll('[data-size-chart]').forEach(function (root) {
      if (!root.__scReady) return;
      var target = null;
      var cands = document.querySelectorAll('.swatch-label .swatch-option-name, .variant__label');
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        if (el.closest('.visually-hidden-label')) continue;
        if (!/\b(sizes?|maat|taille)\b/i.test(el.textContent)) continue;
        if (!el.getBoundingClientRect().width) continue;
        target = el; break;
      }
      if (!target || target.parentNode.querySelector('.sc-trigger--inline')) return;
      var orig = root.querySelector('[data-sc-open]');
      var btn = orig.cloneNode(true);
      btn.removeAttribute('data-sc-open');
      btn.classList.add('sc-trigger--inline');
      btn.style.cssText = 'margin-left:14px;padding:0;letter-spacing:normal;text-transform:none;vertical-align:middle;font-size:13px;';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); orig.click(); });
      target.insertAdjacentElement('afterend', btn);
      orig.style.display = 'none';
      root.style.margin = '0';
    });
  }
  var scQueued = false;
  new MutationObserver(function () {
    if (scQueued) return;
    scQueued = true;
    requestAnimationFrame(function () { scQueued = false; placeInline(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  placeInline();
  // Opnieuw initialiseren na variant-/sectiewissel in de theme editor of quick view
  document.addEventListener('shopify:section:load', window.__sizeChartInit);
})();
